import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Store } from '@ngrx/store';
import { ComponentModel } from '../models/component';
import { ActionModel } from '../models/action';
import { ActionService } from './action.service';
import { ComponentService } from './component.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AdminService {

  currentUser: User;
  components: ComponentModel[];
  actions: ActionModel[];

  /**
   * Load dependencies and get current user from the store
   * @param {Store<any>} store
   * @param {ActionService} actionService
   * @param {ComponentService} componentService
   */
  constructor(private store: Store<any>,
    private actionService: ActionService,
    private componentService: ComponentService) {

    this.store.select('userState').subscribe(user => {
      this.currentUser = user;
    });

  }

  /**
   * Associate actions and components to the current user privileges and profiles
   * @returns {Observable<any>}
   */
  init() {
    return new Observable((observer) => {
      if (this.currentUser && this.components && this.actions) {
        observer.next();
        observer.complete();
      }
      this.actionService.getAllActions().subscribe(actions => {
        this.actions = actions;
        this.componentService.getAllComponents().subscribe(components => {
          this.components = components;
          observer.next();
          observer.complete();
        });
      });
    });
  }

  /**
   * Check if the user can do the action on the component
   * @param {string} componentName
   * @param {string} action
   * @returns {boolean}
   */
  can(componentName: string, action: string): boolean {
    if (!this.currentUser || !this.components || !this.actions) {
      return false;
    }
    const component = this.components.find(c => c.value === componentName);
    if (!component) {
      return false;
    }
    const viewAction = this.actions.find(a => a.value === action);
    const right = this.getRights().find(r => r.component === component.id && r.action === viewAction.id);
    return !!right;
  }

  /**
   * Get user rights
   * @returns {any[]}
   */
  getRights() {
    let rights = [];
    this.currentUser.profiles.forEach(profile => rights.concat(profile.privileges));
    rights = rights.concat(this.currentUser.privileges);
    return rights;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/admin.service.ts